import React from 'react';
import Body from './Body';

const View = (props) => {
  return <Body {...props} />;
};

export default View;
